// ======================================================================
// FILE: src/modules/wms/dashboard/components/StatusDistributionCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Dynamic Status Distribution
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";


// ======================================================================
// STATUS COLORS
// ======================================================================

const COLORS = [
  "#0d6efd",
  "#fd7e14",
  "#ffc107",
  "#20c997",
  "#198754",
  "#6c757d",
  "#dc3545",
];


// ======================================================================
// COMPONENT
// ======================================================================

export default function StatusDistributionCard({
  data = [],
}) {

  // --------------------------------------------------------------------
  // Always work with an array.
  // --------------------------------------------------------------------

  const chartData = Array.isArray(data)
    ? data
    : [];


  // --------------------------------------------------------------------
  // Empty state
  // --------------------------------------------------------------------

  const hasData = chartData.some(
    item => Number(item?.value || 0) > 0
  );


  return (

    <div className="card shadow-sm h-100">


      {/* ================================================================
          HEADER
          ================================================================ */}

      <div className="card-header bg-white">

        <h5 className="mb-0">
          Status Distribution
        </h5>

      </div>


      {/* ================================================================
          BODY
          ================================================================ */}

      <div className="card-body">


        {!hasData ? (

          <div
            className="
              d-flex
              align-items-center
              justify-content-center
              text-muted
            "
            style={{
              height: "320px",
            }}
          >

            No work data available.

          </div>

        ) : (

          <ResponsiveContainer
            width="100%"
            height={320}
          >

            <PieChart>

              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                label
              >

                {chartData.map(
                  (entry, index) => (

                    <Cell
                      key={`${entry?.name || "status"}-${index}`}
                      fill={
                        COLORS[
                          index % COLORS.length
                        ]
                      }
                    />

                  )
                )}

              </Pie>


              <Tooltip />


              <Legend />

            </PieChart>

          </ResponsiveContainer>

        )}

      </div>

    </div>

  );

}